module.exports = __webpack_public_path__ + "static/img/3.f9e8db9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/price/3.png
// module id = qheX
// module chunks = 1